<template>
    <section>
    <div v-if="guidelines[guidelinekey]" class="form-guideline flex items-center" style="margin-top: .5rem">
        <svg style="width: 24px; height: 24px; color: gray" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-2">
            <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
        </svg>
        <div v-html="guidelines[guidelinekey].description"></div>
    </div>
        <div v-else></div>
    </section>
</template>

<script>
export default {
    name: "Guideline",
    props: {
        guidelinekey: {type: String},
        guidelines: {type: Object},
    },
    mounted: function() {
    }


}
</script>

<style scoped>

</style>